import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { first, switchMap, tap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { NewsService } from '../news.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  news;
  newsDetails;
  suggestNews = [];
  path: string;

  constructor(
    private newsService: NewsService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.path = window.location.origin + '/';

    this.route.params.pipe(
      first(),
      switchMap(params => {
        return this.newsService.getNews(Number.parseInt(params['newsId']));
      }),
      switchMap(news => {
        let i: number = 0
        let lastIndex: number = null;
        let ran: number;

        this.news = news.result.DETAIL_NEWS[0];
        this.newsDetails = this.sanitizer.bypassSecurityTrustHtml(news.result.DETAIL_NEWS[0].NEWS_DETAIL);
        // // console.log(this.news);

        while (i !== 2 && news.result.SUGGEST_NEWS.length > 0) {
          ran = Math.floor(Math.random() * news.result.SUGGEST_NEWS.length);
          if (!lastIndex) {
            this.suggestNews[i] = news.result.SUGGEST_NEWS[ran];
            lastIndex = ran;
            i++;
          } else if (lastIndex !== ran) {
            this.suggestNews[i] = news.result.SUGGEST_NEWS[ran];
            i++;
          }
        }
        this.gobalFunctionService.setSEO(this.news.NEWS_TITAL, 'article', this.news.NEWS_DETAIL, this.news.NEWS_PIC);

        // this.suggestNews = news.result.SUGGEST_NEWS;
        return this.newsService.newsReadCountUpdate(this.news.NEWS_ID)
      })
    ).subscribe()
  }

  viewSuggest(path) {
    this.router.navigate(['/news/' + path])
      .then(() => {
        window.location.reload();
      });
  }
}
